import { render } from "./slide22.vue?vue&type=template&id=a42da360&scoped=true"
import script from "./slide22.vue?vue&type=script&lang=js"
export * from "./slide22.vue?vue&type=script&lang=js"

import "./slide22.vue?vue&type=style&index=0&id=a42da360&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a42da360"]])

export default __exports__